document.addEventListener("DOMContentLoaded", function () {
  const productOptions = document.querySelectorAll(".product-option-select");
  const qtySelectors = document.querySelectorAll(".custom-qty-selector");
  let variantInput = null;
  let sellingPlanInput = null;
  let currentProduct = null;

  function updateVariantId() {
    // Get current product variant ID
    currentProduct = this.parentNode.parentNode.querySelector(
      "input[name=product-id]"
    ).value;
    // Get the hidden input field to store Variant ID
    variantInput = document.getElementById(
      `selected-variant-id-${currentProduct}`
    );
    // Get the hidden input field to store Selling Plan ID
    sellingPlanInput = document.getElementById(
      `selected-selling-plan-id-${currentProduct}`
    );

    // Set variantID according to the current Select, whether it's Variant or Selling Plan
    let selectedVariantID = this.value;
    if (!this.classList.contains("selling-plan-select")) {
      selectedVariantID =
        this.querySelectorAll("option")[this.selectedIndex].dataset.variantId;
      variantInput.value = selectedVariantID;
    } else {
      sellingPlanInput.value = selectedVariantID;
    }
  }

  if (qtySelectors) {
    qtySelectors.forEach((selector) => {
      const card =
        selector.closest('[class~="#product-card"]') || selector.parentElement; // adapte selon ta structure
      const minusBtn = selector.querySelector('[data-action="minus"]');
      const plusBtn = selector.querySelector('[data-action="plus"]');
      const input = selector.querySelector('input[name="quantity"]');
      const priceEl = card.querySelector('[class~="#product-card-price"]');

      // Initial setup
      if (!priceEl) return;

      const basePriceText = priceEl.textContent.trim();
      const basePrice = parseFloat(
        basePriceText.replace(/[^\d,.]/g, "").replace(",", ".")
      );

      // Store the currency symbol (e.g. $ or €)
      const currencySymbol = basePriceText.replace(/[\d.,\s]/g, "").trim();

      updateState();

      plusBtn.addEventListener("click", () => {
        let current = parseInt(input.value) || 1;
        current++;
        input.value = current;
        updateState();
        updatePrice(current);
      });

      minusBtn.addEventListener("click", () => {
        let current = parseInt(input.value) || 1;
        if (current > 1) {
          current--;
          input.value = current;
          updateState();
          updatePrice(current);
        }
      });

      function updateState() {
        const value = parseInt(input.value) || 1;
        if (value <= 1) {
          minusBtn.setAttribute("disabled", "true");
          minusBtn.classList.add("disabled");
        } else {
          minusBtn.removeAttribute("disabled");
          minusBtn.classList.remove("disabled");
        }
      }

      function updatePrice(quantity) {
        const newTotal = (basePrice * quantity).toFixed(2);
        // Remettre au format monétaire local
        priceEl.textContent = currencySymbol + newTotal.replace(".", ",");
      }
    });
  }

  // Loop all Select elements and add event handler
  productOptions.forEach((select) => {
    select.addEventListener("change", updateVariantId);
  });
});
